import { connect } from 'react-redux';

import CustomCollectionCardsList from 'components/CustomCollectionCardsList';
import {
  getCustomCollectionItems,
  calculateCustomCollectionLayout,
  getCustomCollectionMobileNumberOfColumns,
} from 'state/selectors/collection';

const mapStateToProps = state => {
  const nColumnsMobile = getCustomCollectionMobileNumberOfColumns(state);

  const items = getCustomCollectionItems(state);

  const layout1Column = calculateCustomCollectionLayout({ state, items, nColumns: 1 });
  const layout2Column = calculateCustomCollectionLayout({ state, items, nColumns: 2 });
  const layout3Column = calculateCustomCollectionLayout({ state, items, nColumns: 3 });
  const layout4Column = calculateCustomCollectionLayout({ state, items, nColumns: 4 });

  return {
    layout1Column,
    layout2Column,
    layout3Column,
    layout4Column,
    nColumnsMobile,
  };
};

export default connect(mapStateToProps)(CustomCollectionCardsList);
